<template>
    <div>
        <OrdersDetailsPage v-if="orderId" :order-id="orderId" />
        <OrdersPage v-else />
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import OrdersPage from './components/orders/OrdersPage.vue'
import OrdersDetailsPage from './components/orders/OrdersDetailsPage.vue'
import { watchEffect } from 'vue'
import useEventStore from './utilities/useEvent'
import { getPlatformName } from './utilities/usePlatformSettings'

const eventStore = useEventStore()

const orderId = ref<string | null>(null)

const setOrderId = () => {
    orderId.value = window.location.hash.split('#')[1]
}

watchEffect(() => {
    setOrderId()
})

window.onhashchange = () => {
    setOrderId()
    eventStore.trackEvent({
        event: 'visit_order',
        data: { order_id: orderId.value },
    })
}
</script>

<style scoped></style>
